/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_Upcoming_BookingsInputs */

const en_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming bookings`)
};

const de_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine anstehenden Buchungen.`)
};

const es_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay próximas reservas.`)
};

const fr_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de réservations à venir.`)
};

const nl_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen aankomende reserveringen`)
};

const it_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna prenotazione imminente.`)
};

const pt_br2_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma reserva próxima.`)
};

const pl_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak nadchodzących rezerwacji.`)
};

const hu_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincsenek jövőbeli foglalások.`)
};

const ro_admin_dashboard_no_upcoming_bookings = /** @type {(inputs: Admin_Dashboard_No_Upcoming_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio rezervare viitoare`)
};

/**
* | output |
* | --- |
* | "No upcoming bookings" |
*
* @param {Admin_Dashboard_No_Upcoming_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_upcoming_bookings = /** @type {((inputs?: Admin_Dashboard_No_Upcoming_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_Upcoming_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "de") return de_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "es") return es_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "it") return it_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_upcoming_bookings(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_upcoming_bookings(inputs)
	return ro_admin_dashboard_no_upcoming_bookings(inputs)
});
export { admin_dashboard_no_upcoming_bookings as "admin.dashboard.no_upcoming_bookings" }